export default {
    state: {
        data: null,
        loadingData: null
    },
    mutations: {
        setUserData(state, payload) {
            state.data = payload
        },
        clearUserData(state, payload) {
            state.data = null
        },
        setUserLoadingData(state, payload) {
            state.loadingData = payload
        },
    },
    actions: {
        setUserData({ commit }, payload) {
            commit('setUserData', payload)
        },
        clearUserData({ commit }, payload) {
            commit('clearUserData', payload)
        },
        setUserLoadingData({ commit }, payload) {
            commit('setUserLoadingData', payload)
        },
    }
}